import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import "./Home.css";
import { Link } from "react-router-dom";
const Blog = () => {
  return (
    <div className="ttm-rowrr bolg-section_3 clearfix">
      <Container>
        {/* <div className="row">
          <div className="col-lg-8 col-md-10 col-sm-10 m-auto">
         
            <div className="section-title title-style-center_text">
              <div className="title-header">
                <h3>Blog And Updates</h3>
                <h2 className="title blog_section_single">Get Our Every Single Update</h2>
              </div>
            </div>
           
          </div>
        </div> */}
        <Row>
          <Col className="main_col_after">
            <p className="we_offer_home_para" style={{ textAlign: "center" }}>
              Blog And Updates
            </p>
            <h5
              className="we_offer_home_h5"
              style={{ textAlign: "center", marginBottom: "50px" }}
            >
              Get Our Every Single Update
            </h5>
          </Col>
        </Row>

        <Row>
          <Col md={4} style={{ marginBottom: "10px" }}>
            <div className="post-item-wrap">
              <div className="post-feature-wrap">
                <div className="post-feature post-thumbnail">
                                      <Link to="/blog/understanding-rhinoplasty-what-you-need-to-know-about-nose-reshaping-surgery">

                    <img src="https://img.freepik.com/premium-photo/young-woman-eyebrow-correction-cosmetology-clinic_83055-1305.jpg?w=900" />{" "}
                  </Link>
                </div>
              </div>
              <div className="post-info" style={{ marginTop: "8px" }}>
                <div className="post-date" style={{ textAlign: "start" }}>
                  Oct 06, 2024{" "}
                </div>
                <h3
                  className="post-title"
                  style={{ textAlign: "start", marginTop: "5px" }}
                >
                                     <Link to="/blog/understanding-rhinoplasty-what-you-need-to-know-about-nose-reshaping-surgery">

                    Understanding Rhinoplasty: What You Need to Know About Nose
                    Reshaping Surgery
                  </Link>
                </h3>
                <div
                  className="featured-desc"
                  style={{ marginLeft: "0px", textAlign: "start" }}
                >
                  Rhinoplasty, commonly known as a "nose job," is one of the
                  most popular plastic surgeries....
                </div>
              </div>
            </div>
            {/* <div className="featured-imagebox featured-imagebox-post style2">
              <div className="featured-imagebox-post-inner">
                <div className="featured-thumbnail">
                  <img
                    width={700}
                    height={620}
                    className="img-fluid blog-image-resolution"
                    src="https://img.freepik.com/premium-photo/young-woman-eyebrow-correction-cosmetology-clinic_83055-1305.jpg?w=900"
                    // src="https://img.freepik.com/free-photo/woman-making-makeup-vlog-with-her-smartphone_23-2149039663.jpg?t=st=1730121336~exp=1730124936~hmac=c1345cc34825a008cad87cd3475a0ccef3f046d4e9a39f09d09ba47a17fbffda&w=740"
                    alt="image"
                  />
                </div>
                <div className="ttm-box-post-date">
                  <span className="ttm-entry-date">
                    <time
                      className="entry-date"
                      dateTime="2019-01-16T07:07:55+00:00"
                    >
                      22<span className="entry-month entry-year">Oct</span>
                    </time>
                  </span>
                </div>
              </div>
              <div className="featured-content">
                <div className="featured-title">
                  <h3>
                    <Link to="/blog/understanding-rhinoplasty-what-you-need-to-know-about-nose-reshaping-surgery">
                      Understanding Rhinoplasty: What You Need to Know About
                      Nose Reshaping Surgery
                    </Link>
                  </h3>
                </div>
                <div className="featured-desc">
                  Rhinoplasty, commonly known as a "nose job," is one of the
                  most popular plastic surgeries worldwide, helping individuals
                  refine the appearance of their nose....
                </div>
              </div>
            </div> */}
          </Col>
          <Col md={4} style={{ marginBottom: "10px" }}>
            <div className="post-item-wrap">
              <div className="post-feature-wrap">
                <div className="post-feature post-thumbnail">
                  <Link to="/blog/understanding-the-procedure-and-its-effective-treatments-by-an-expert">
                    <img src="https://img.freepik.com/premium-photo/medium-shot-man-with-blank-shirt_1165404-61040.jpg?w=900" />{" "}
                  </Link>
                </div>
              </div>
              <div className="post-info" style={{ marginTop: "8px" }}>
                <div className="post-date" style={{ textAlign: "start" }}>
                  Oct 25, 2024{" "}
                </div>
                <h3
                  className="post-title"
                  style={{ textAlign: "start", marginTop: "5px" }}
                >
                   <Link to="/blog/understanding-the-procedure-and-its-effective-treatments-by-an-expert">
                    Understanding the Procedure and Its Effective Treatments by
                    an Expert's
                  </Link>
                </h3>
                <div
                  className="featured-desc"
                  style={{ marginLeft: "0px", textAlign: "start" }}
                >
                  When it comes to undergoing a surgical procedure, particularly
                  plastic surgery, understanding...
                </div>
              </div>
            </div>
            {/* <div className="featured-imagebox featured-imagebox-post style2">
              <div className="featured-imagebox-post-inner">
                <div className="featured-thumbnail">
                  <img
                    width={700}
                    height={620}
                    className="img-fluid blog-image-resolution"
                    src="https://img.freepik.com/premium-photo/medium-shot-man-with-blank-shirt_1165404-61040.jpg?w=900"
                    alt="image"
                  />
                </div>
                <div className="ttm-box-post-date">
                  <span className="ttm-entry-date">
                    <time
                      className="entry-date"
                      dateTime="2019-01-16T07:07:55+00:00"
                    >
                      25<span className="entry-month entry-year">Oct</span>
                    </time>
                  </span>
                </div>
              </div>
              <div className="featured-content">
                <div className="featured-title">
                  <h3>
                    <Link to="/blog/understanding-the-procedure-and-its-effective-treatments-by-an-expert">
                      Understanding the Procedure and Its Effective Treatments
                      by an Expert's
                    </Link>
                  </h3>
                </div>
                <div className="featured-desc">
                  When it comes to undergoing a surgical procedure, particularly
                  plastic surgery, understanding the process, benefits,...
                </div>
              </div>
            </div> */}
          </Col>
          <Col md={4}>
            <div className="post-item-wrap">
              <div className="post-feature-wrap">
                <div className="post-feature post-thumbnail">
                                     <Link to="/blog/why-you-need-a-plastic-surgeon-understanding-the-benefits-of-specialized-care">

                    <img src="https://img.freepik.com/free-photo/female-doctor-diagnosing-melanoma-body-female-patient_23-2149365813.jpg?t=st=1730121545~exp=1730125145~hmac=cbcac40bce87ff90d5a23dc96ffe60de6e0b958bb996ca2dde6c315577af05de&w=900" />{" "}
                  </Link>
                </div>
              </div>
              <div className="post-info" style={{ marginTop: "8px" }}>
                <div className="post-date" style={{textAlign:'start'}}>Oct 27, 2024 </div>
                <h3
                  className="post-title"
                  style={{ textAlign: "start", marginTop: "5px" }}
                >
                                      <Link to="/blog/why-you-need-a-plastic-surgeon-understanding-the-benefits-of-specialized-care">

                    Why You Need a Plastic Surgeon: Understanding the Benefits
                    of Specialized Care
                  </Link>
                </h3>
                <div
                  className="featured-desc"
                  style={{ marginLeft: "0px", textAlign: "start" }}
                >
                  Plastic surgery has grown in popularity and versatility over
                  recent decades, catering.....
                </div>
              </div>
            </div>
            {/* <div className="featured-imagebox featured-imagebox-post style2">
              <div className="featured-imagebox-post-inner">
                <div className="featured-thumbnail">
                  <img
                    width={700}
                    height={620}
                    className="img-fluid blog-image-resolution"
                    src="https://img.freepik.com/free-photo/female-doctor-diagnosing-melanoma-body-female-patient_23-2149365813.jpg?t=st=1730121545~exp=1730125145~hmac=cbcac40bce87ff90d5a23dc96ffe60de6e0b958bb996ca2dde6c315577af05de&w=900"
                    alt="image"
                  />
                </div>
                <div className="ttm-box-post-date">
                  <span className="ttm-entry-date">
                    <time
                      className="entry-date"
                      dateTime="2019-01-16T07:07:55+00:00"
                    >
                      27<span className="entry-month entry-year">Oct</span>
                    </time>
                  </span>
                </div>
              </div>
              <div className="featured-content">
                <div className="featured-title">
                  <h3>
                    <Link to="/blog/why-you-need-a-plastic-surgeon-understanding-the-benefits-of-specialized-care">
                      Why You Need a Plastic Surgeon: Understanding the Benefits
                      of Specialized Care
                    </Link>
                  </h3>
                </div>
                <div className="featured-desc">
                  Plastic surgery has grown in popularity and versatility over
                  recent decades, catering to diverse needs beyond
                  aesthetics.....
                </div>
              </div>
            </div> */}
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Blog;
